import React, {Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {Alert, Col, Label, Row, Table} from "reactstrap";
import BigNumber from "bignumber.js";
import {formatUsd, sortObjectByKey, uuidv4} from "../../helpers/Util";
import {connect} from "react-redux";
import {clearCart, removeFromCart} from "../../store/cart/actions";
import Select from "react-select";
import {createOrder} from "../../helpers/orders";
import constants from "../../constants";
import {getGroupMembers} from "../../helpers/groups";
import BatchTrade from "../../components/Common/BatchTrade";

class ProductCheckout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            subtotal: props.product ? 0 : BigNumber.sum(...props.items.map(ci => ci.invest)).toNumber(),
            minInvestUsd: (props.product && props.product.minInvestUsd) ? new BigNumber(props.product.minInvestUsd).toNumber() : 0,
            groupOptionGroup: [],
            clientOptionGroup: [],
            selectedClients: [],
            combineTrades: false,
            loading: false,
            success: false,
            error: null
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectGroup = this.handleSelectGroup.bind(this);
        this.handleSelectClients = this.handleSelectClients.bind(this);
    }

    componentDidMount() {
        this.updateClients();
        this.updateGroups();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.product && this.props.product !== prevProps.product && this.props.product.minInvestUsd) {
            this.setState({minInvestUsd: new BigNumber(this.props.product.minInvestUsd).toNumber()});
        }
        if (!this.props.product && this.props.items !== prevProps.items) {
            this.setState({subtotal: BigNumber.sum(...this.props.items.map(ci => ci.invest)).toNumber()});
            if (this.props.items.length === 0) {
                if (this.props.toggle) {
                    this.props.toggle();
                }
            }
        }
        if (this.props.custodians !== prevProps.custodians || this.props.clients !== prevProps.clients) {
            this.updateClients();
        }
        if (this.props.groups !== prevProps.groups) {
            this.updateGroups();
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    updateClients() {
        const product = this.props.product || (this.props.items.length ? this.props.items[0].product : null);
        const custodians = this.props.custodians;
        if (custodians.length) {
            const clientsByCustodian = {};
            sortObjectByKey(this.props.clients, "name").forEach(cl => {
                if (cl.status === "ACTIVE" && (!product || !product.custodianId || product.custodianId === cl.custodianId)) {
                    if (!clientsByCustodian[cl.custodianId]) {
                        clientsByCustodian[cl.custodianId] = [];
                    }
                    clientsByCustodian[cl.custodianId].push(cl);
                }
            });
            this.setState({
                hideClientSelect: false,
                clientOptionGroup: Object.keys(clientsByCustodian).map(custodianId => {
                    const custodian = custodians.find(c => c.id.toString() === custodianId);
                    return {
                        label: custodian ? custodian.name : "Custodian " + custodianId,
                        options: clientsByCustodian[custodianId].map(cl => {
                            const name = cl.name;
                            let availableUsd;
                            if (cl.balances) {
                                const usd = cl.balances.find(b => b.currency === "usd");
                                availableUsd = usd ? usd.available : "0";
                            }
                            const tag = `${name}` + (cl.email ? ` (${cl.email})` : "");
                            return {
                                label: `${tag} - ${formatUsd(availableUsd)} available`,
                                value: cl,
                                color: (availableUsd === "0" || new BigNumber(this.state.subtotal || this.state.minInvestUsd).isGreaterThan(availableUsd)) ? "#f46a6a" : "#34c38f"
                            };
                        }),
                        custodianId
                    };
                })
            });
        }
    }

    updateGroups() {
        this.setState({
            groupOptionGroup: this.props.groups.map(group => ({
                label: group.name,
                value: group
            }))
        });
    }

    handleSelectGroup(select) {
        this.setState({
            selectedGroup: select
        }, () => {
            if (!select) {
                return;
            }
            getGroupMembers(select.value.id).then(members => {
                const option = this.state.clientOptionGroup.find(og => og.custodianId === select.value.custodianId.toString());
                if (!option) {
                    return;
                }
                const selected = option.options.filter(o =>
                    members.individualClients.some(m => (m === o.value.id && o.value.clientType === "individual")) ||
                    members.corporateClients.some(m => (m === o.value.id && o.value.clientType === "corporate"))
                );
                this.handleSelectClients(selected);
            });
        });
    }

    handleSubmit() {
        this.setState({loading: true});
        if (!this.state.selectedClients || this.state.selectedClients.length === 0) {
            this.setState({
                error: new Error("Please select at least one client."),
                loading: false
            });
            return;
        }
        for (let i = 0; i < this.state.selectedClients.length; i++) {
            const cl = this.state.selectedClients[i].value;
            let availableUsd;
            if (cl.balances) {
                const usd = cl.balances.find(b => b.currency === "usd");
                availableUsd = usd ? usd.available : "0";
            }
            if (!availableUsd || availableUsd === "0" || new BigNumber(this.state.subtotal || this.state.minInvestUsd).isGreaterThan(availableUsd)) {
                this.setState({
                    error: new Error(`${cl.email} doesn't not have sufficient balance.`),
                    loading: false
                });
                return;
            }
        }
        const orderItems = this.props.product ? [{
            productId: this.props.product.id,
            investAll: true
        }] : this.props.items.map(oi => ({
            productId: oi.product.id,
            invest: oi.invest
        }));
        const clients = this.state.selectedClients.map(cl => cl.value);
        createOrder({
            individualClients: clients.filter(cl => cl.clientType === "individual").map(cl => cl.id),
            corporateClients: clients.filter(cl => cl.clientType === "corporate").map(cl => cl.id),
            combineTrades: this.state.combineTrades,
            algorithms: this.props.algorithms,
            orderItems
        }).then(() => {
            this.props.history.push("/orders");
        }).catch(err => {
            this.setState({
                error: err,
                loading: false
            });
        });
    }

    handleSelectClients(select) {
        this.setState({
            selectedClients: select || []
        });
    }

    handleCombineTrades(checked) {
        this.setState({
            combineTrades: this.state.selectedClients.length > 1 ? checked : false
        });
    }

    render() {
        const success = this.state.success;
        const error = this.state.error;
        const product = this.props.product;
        const group = this.state.group;
        return (
            <React.Fragment>
                {success && <Alert className="mt-3 mb-0" color="success">Order placed.</Alert>}
                {!success && <Row>
                    <Col xl="6">
                        {product && <div>
                            {product.description && <p>{product.description}</p>}
                            <Label>Product detail:</Label>
                            {product.detail && <div dangerouslySetInnerHTML={{__html: product.detail}}/>}
                        </div>}
                        {!product && <div>
                            <h6>Products:</h6>
                            <Table className="table-borderless">
                                <tbody>
                                {this.props.items.map((ci, idx) => <tr key={"cart-" + idx}>
                                    <td>
                                        {formatUsd(ci.invest)}
                                        <br/>
                                        <Link className="text-danger" to="#"
                                              onClick={() => {
                                                  this.props.removeFromCart(ci.product);
                                                  this.updateClients();
                                              }}>Delete</Link>
                                    </td>
                                    <td>
                                        <b>{ci.product.title}</b>
                                        <br/>
                                        {ci.product.description}
                                    </td>
                                </tr>)}
                                </tbody>
                            </Table>
                        </div>}
                    </Col>
                    <Col xl="6">
                        {product && <div>
                            {product.minInvestUsd &&
                                <h6>Minimum: <span className="text-warning">{formatUsd(product.minInvestUsd)}</span>
                                </h6>}
                            {product.maxInvestUsd &&
                                <h6>Maximum: <span className="text-warning">{formatUsd(product.maxInvestUsd)}</span>
                                </h6>}
                        </div>}
                        {!product && <div>
                            <h6>Subtotal:</h6>
                            <p>{formatUsd(this.state.subtotal)}</p>
                        </div>}
                        {!this.state.selectedClients.length && !!this.props.groups.length && <div className="mb-3">
                            <Label>Select a group (optional)</Label>
                            <Select
                                placeholder="Filter by group"
                                value={group}
                                onChange={this.handleSelectGroup}
                                options={this.state.groupOptionGroup}
                                isClearable={true}
                            />
                        </div>}
                        <h6>Clients:</h6>
                        <Select
                            value={this.state.selectedClients}
                            isMulti={true}
                            onChange={this.handleSelectClients}
                            options={this.state.clientOptionGroup}
                            styles={constants.clientSelectStyles}
                        />
                        {
                            this.state.selectedClients.length > 1 &&
                            <div className="my-2">
                                <BatchTrade checked={this.state.combineTrades}
                                            handleChange={(checked) => this.handleCombineTrades(checked)}/>
                            </div>
                        }
                        {error ?
                            <Alert className="mt-3 mb-0" color="danger">{error.message}</Alert> : null}
                        {this.state.selectedClients.length > 0 && <h6 className="mt-3">Order Review:</h6>}
                        {this.state.selectedClients.map(sc => {
                            const cl = sc.value;
                            let availableUsd;
                            if (cl.balances) {
                                const usd = cl.balances.find(b => b.currency === "usd");
                                availableUsd = usd ? usd.available : "0";
                            }
                            const items = product ? [{invest: 0, product}] : this.props.items;
                            return <div key={uuidv4()}>
                                <table className="table table-sm text-monospace">
                                    <thead>
                                    <tr>
                                        <th style={{width: "50%"}}>{cl.name}</th>
                                        <th style={{width: "50%", textAlign: "right"}}>Available
                                            Cash: {formatUsd(availableUsd)}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {items.map(i => {
                                        let rows = [];
                                        const invest = i.invest || availableUsd;
                                        const tokens = i.product.allocations.filter(a => a.currency !== "usd");
                                        const usd = i.product.allocations.find(a => a.currency === "usd");
                                        rows = tokens.map(t => {
                                            return <tr key={uuidv4()}>
                                                <td style={{width: "50%"}}>Purchasing {t.percentage * 100}% {t.currency.toUpperCase()}</td>
                                                <td style={{
                                                    width: "50%",
                                                    textAlign: "right"
                                                }}>{formatUsd(new BigNumber(invest).multipliedBy(t.percentage).toNumber())}</td>
                                            </tr>;
                                        });
                                        if (usd) {
                                            rows.push(<tr key={uuidv4()}>
                                                <td style={{width: "50%"}}>Leaving {usd.percentage * 100}% cash</td>
                                                <td style={{
                                                    width: "50%",
                                                    textAlign: "right"
                                                }}>{formatUsd(new BigNumber(invest).multipliedBy(usd.percentage).toNumber())}</td>
                                            </tr>);
                                        }
                                        return rows;
                                    })}
                                    </tbody>
                                </table>
                            </div>;
                        })}
                        {!this.state.loading &&
                        <Link to="#" className="btn btn-primary float-right mt-3" onClick={this.handleSubmit}>
                            Place Order
                        </Link>}
                    </Col>
                </Row>}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {items} = state.Cart;
    const {custodians, clients, groups} = state.Info;
    return {items, custodians, clients, groups};
};

export default withRouter(connect(mapStateToProps, {
    removeFromCart,
    clearCart,
    createOrder
})(ProductCheckout));
